import { Box, Flex, Text, VStack, Badge } from '@chakra-ui/react';
import { Task, TaskStatus } from '../../../models';
import { formatDateSubForm } from '../../../utils';

export const LinkedTask = ({
  task,
  openTask,
  version,
}: {
  task: {
    id: number;
    name: string;
    level: number;
    createdAt: string;
    modifiedAt: null | string;
    status: TaskStatus;
  };
  openTask: any;
  version: number;
}) => {
  return (
    <Box
      borderWidth="1px"
      borderRadius="md"
      p={4}
      _hover={{ borderColor: task.level === 0 ? '' : 'red.500' }} // To add hover effect
      borderColor="gray.200"
      sx={{ cursor: task.level === 0 ? '' : 'pointer' }}
      onClick={() => (task.level === 0 ? () => {} : openTask(task.id))}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Flex alignItems="center">
          <svg
            width="18"
            height="22"
            viewBox="0 0 18 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 1.62427V1.62427C11 3.01985 11 3.71764 11.1722 4.28544C11.56 5.56384 12.5605 6.56426 13.8389 6.95206C14.4067 7.1243 15.1044 7.1243 16.5 7.1243V7.1243M6 11.1243H12M6 15.1243H10M17 8.77523V14.7243C17 16.9645 17 18.0846 16.564 18.9402C16.1805 19.6929 15.5686 20.3048 14.816 20.6883C13.9603 21.1243 12.8402 21.1243 10.6 21.1243H7.4C5.15979 21.1243 4.03968 21.1243 3.18404 20.6883C2.43139 20.3048 1.81947 19.6929 1.43597 18.9402C1 18.0846 1 16.9645 1 14.7243V7.52427C1 5.28406 1 4.16395 1.43597 3.30831C1.81947 2.55566 2.43139 1.94373 3.18404 1.56024C4.03968 1.12427 5.15979 1.12427 7.4 1.12427H9.34903C10.3274 1.12427 10.8166 1.12427 11.2769 1.23479C11.6851 1.33277 12.0753 1.49439 12.4331 1.71371C12.8368 1.96107 13.1827 2.30698 13.8745 2.99878L15.1255 4.24975C15.8173 4.94156 16.1632 5.28746 16.4106 5.69113C16.6299 6.04902 16.7915 6.4392 16.8895 6.84734C17 7.30769 17 7.79687 17 8.77523Z"
              stroke="#EC5E2A"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <Text ml={2} fontWeight="bold" fontSize="lg">
            {task.name}
          </Text>
        </Flex>
        <Box>
          <Badge
            color="custom_orange.2"
            fontSize={'sm'}
            background="custom_orange.4"
            sx={{ padding: '4px', borderRadius: '4px' }}
          >
            V.{version}
          </Badge>
          {task.level === 0 && (
            <Badge
              color="custom_blue.2"
              fontSize={'sm'}
              background="custom_blue.4"
              sx={{ padding: '4px', borderRadius: '4px', marginLeft: '8px' }}
            >
              {'Current'}
            </Badge>
          )}
        </Box>
      </Flex>
      <Flex justifyContent="space-between" mt={2}>
        <Text display={'flex'} gap="4px" flexDir={'row'}>
          <Text color="green.500">Created:</Text>
          <Text>{formatDateSubForm(task.createdAt)}</Text>
        </Text>
        {task.modifiedAt && task.status === TaskStatus.Completed && (
          <Text display={'flex'} gap="4px" flexDir={'row'}>
            <Text color="red.500">Closed:</Text>
            <Text>{formatDateSubForm(task.modifiedAt)}</Text>
          </Text>
        )}
      </Flex>
    </Box>
  );
};
